import '../modal.css';
import {ModalProps} from "../ModalProps";

export const ModelPolicy = (policy: ModalProps) => {

    if (!policy.isOpen) return null;
    return (
        <div className={'modal-overlay'}>
            <div className={'modal-order'}>
                <button className="modal-close-button"
                        onClick={policy.onClose}
                        aria-label="Закрыть окно">
                </button>
                <h2 className={'modal-policy-title'}>
                    Политика конфиденциальности
                </h2>
                <div className="modal-policy-body">
                    <p>1. Общие положения</p>
                    <p>1.1. Настоящая Политика конфиденциальности определяет общие условия сбора и обработки
                        персональных
                        данных пользователей сайта агентство-праздник.рф, принадлежащего ИП Чернякова А.С. </p>
                    <p>1.2. ИП Чернякова А.С. осуществляет обработку следующих персональных данных:</p>
                    <ul>
                        <li>полное имя;</li>
                        <li>номер мобильного телефона;</li>
                    </ul>
                    <p><b>2. Цели обработки персональных данных</b></p>
                    <p>2.1. Оператор ИП Чернякова А.С. обрабатывает персональные данные пользователей с целью:
                        предоставления услуг;</p>
                    <p><b>3. Доступ третьих лиц к персональным данным</b></p>
                    <p>3.1. Оператор Чернякова А.С. может передать персональные данные пользователя третьей
                        стороне в следующих случаях:</p>
                    <ul>
                        <li>если передача персональных данных необходима для услуги;</li>
                        <li>если пользователь дал согласие на осуществление передачи своих данных третьей стороне;</li>
                    </ul>
                    <p><b>4. Обязанности оператора ИП Чернякова А.С. по защите персональных данных</b></p>
                    <p>4.1. Оператор ИП Чернякова А.С. обязан принимать необходимые организационные
                        и технические меры для обеспечения конфиденциальности, целостности
                        и доступности персональных данных пользователей.</p>
                    <p>4.2. Оператор ИП Чернякова А.С. обязан своевременно производить оценку соответствия
                        требованиям законодательства РФ
                        в области защиты информации.</p>
                    <p><b>5. Обратная связь</b></p>
                    <p>5.1. Все предложения и вопросы по использованию сайта следует направлять
                        в службу поддержки по адресу электронной почты mail@агентство-праздник.рф</p>
                </div>
            </div>

        </div>
    )
}